import React from "react";
import "./index.css";
import VispeahenApp from "./VispeahenApp";
import { BrowserRouter } from "react-router-dom";
import { createStore, applyMiddleware } from "redux";
import RootReducer from "./ui/RootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import LoginPopup from "../src/ui/GeneralComponents/LoginPopup/LoginPopup"
import { renderApp } from "./Utils/ReactRootHelper";

import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-alpine.css";

import { MonacoWebpackPlugin } from './ui/GeneralComponents/MonacoEditor/MonacoWebpackPlugin';
import { LicenseManager as AgGridLicenseManager } from "@ag-grid-enterprise/core";

MonacoWebpackPlugin.setupEnvironment();
AgGridLicenseManager.setLicenseKey("Evaluation_License-_Not_For_Production_Valid_Until_28_July_2019__MTU2NDI2ODQwMDAwMA==db32728bad1d3ee14ef344c27f0b42be");

export const store = createStore(
  RootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

/* let lastTime = performance.now();

const tick = () => {
  const now = performance.now();
  const delta = now - lastTime;
  lastTime = now;

  if (document.getElementById("performance-metrics")) {
    const { jsHeapSizeLimit, totalJSHeapSize } = performance.memory;

    const total = (totalJSHeapSize / (1024 * 1024)).toFixed(2);
    const limit = (jsHeapSizeLimit / (1024 * 1024)).toFixed(2);
    const ratio = (total / limit * 100).toFixed(2);

    if (ratio >= 99) {
      document.getElementById("performance-metrics").style.background = "red";
      document.getElementById("performance-metrics").style.color = "white";
    } else if (ratio > 90) {
      document.getElementById("performance-metrics").style.background = "orange";
      document.getElementById("performance-metrics").style.color = "black";
    } else if (ratio > 70) {
      document.getElementById("performance-metrics").style.background = "yellow";
      document.getElementById("performance-metrics").style.color = "black";
    } else {
      document.getElementById("performance-metrics").style.background = "green";
      document.getElementById("performance-metrics").style.color = "white";
    }

    document.getElementById("heapSizeRatio").innerText = `${ratio}%`
    document.getElementById("jsHeapSizeLimit").innerText = `${limit} MB`
    document.getElementById("totalJSHeapSize").innerText = `${total} MB`
    document.getElementById("performance-metrics-delta").innerText = `${delta.toFixed(0)} ms` 
  }

  setTimeout(tick, 1000);
} */

// Use new createRoot API (React 18) or fallback to ReactDOM.render (React 17)
const container = document.getElementById("root");
renderApp(
  <Provider store={store}>
    <LoginPopup />
    <BrowserRouter basename="/">
      <VispeahenApp />
    </BrowserRouter>
    <div
      id="performance-metrics"
      style={{
        position: "fixed",
        bottom: 0,
        right: 0,
        display: "flex",
        background: "black",
        color: "white",
        zIndex: 9999,
        fontSize: 10,
        textAlign: "center",
      }}
    >
      {/* <div style={{padding: "4px 0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 80, borderRight: "1px solid" }}>
        <span style={{borderBottom: "1px solid", width: "100%", paddingBottom: 4}}>Heap Ratio</span>
        <span style={{width: "100%", paddingTop: 4}} id="heapSizeRatio"></span>
      </div>
      <div style={{padding: "4px 0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 80, borderRight: "1px solid" }}>
        <span style={{borderBottom: "1px solid", width: "100%", paddingBottom: 4}}>Heap Limit</span>
        <span style={{width: "100%", paddingTop: 4}} id="jsHeapSizeLimit"></span>
      </div>
      <div style={{padding: "4px 0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 80, borderRight: "1px solid" }}>
        <span style={{borderBottom: "1px solid", width: "100%", paddingBottom: 4}}>Total Heap</span>
        <span style={{width: "100%", paddingTop: 4}} id="totalJSHeapSize"></span>
      </div>
      <div style={{ padding: "4px 0", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 80 }}>
        <span style={{borderBottom: "1px solid", width: "100%", paddingBottom: 4}}>Time Delta</span>
        <span style={{width: "100%", paddingTop: 4}} id="performance-metrics-delta"></span>
      </div> */}
    </div>
  </Provider>,
  container
);

/* tick(); */
